import * as yup from 'yup';

export default class CheckoutHandler {

  constructor() {

    this.form = document.querySelector('.js-cart-item-form');
    this.formActualParent = document.querySelector('.js-cart');
    this.formNewParent = document.querySelector('.js-cart-container-mobile');
    this.handleFormMovement = this.handleFormMovement.bind(this);
    this.validateData = this.validateData.bind(this);
    window.addEventListener("load", this.handleFormMovement);
    window.addEventListener("resize", this.handleFormMovement);
    this.form.addEventListener('submit', this.validateData);
  }

  handleFormMovement() {
    if (window.innerWidth > 768) {
      this.formActualParent.append(this.form);
    } else {
      this.formNewParent.append(this.form);
    }
  }

  validateData(e) {
    e.preventDefault();
    var formData = new FormData(this.form);
    var termsConditions = formData.get("terms_conditions");

    var errorParagraphs = this.form.querySelectorAll(".cart-item__error");

    if (errorParagraphs && errorParagraphs.length) {
      for (var i = 0; i < errorParagraphs.length; i++) {
        var element = errorParagraphs[i];
        element.remove();
      }
    }

    checkoutSchema
      .validate({
        terms_conditions: termsConditions ? true : false
      }, {
        abortEarly: false
      })
      .then((r) => {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({'event':'proceed-to-payment'});
        this.form.submit();
      })
      .catch((e) => {
        e.inner.forEach(function (e) {
          var input = document.querySelector('.js-cart-item-form').querySelectorAll(`[name="${e.path}"]`);
          var paragraph = document.createElement("p");
          paragraph.innerHTML = e.message;
          paragraph.classList = "cart-item__error";
          input[0].closest('.cart-item__form-tos').append(paragraph);
        });
      });
  }
}

var checkoutSchema = yup.object().shape({
  terms_conditions: yup.boolean()
    .required("The terms and conditions must be accepted.")
    .oneOf([true], "The terms and conditions must be accepted."),
});
